import script from "./videoPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./videoPlay.vue?vue&type=script&setup=true&lang=js"

import "./videoPlay.vue?vue&type=style&index=0&id=52b75d14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@5.110.3_clean-css@5.3.3_c_fd8bdb85bb9a93cd57e0f6a421dc3a81/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b75d14"]])

export default __exports__